import React from "react";
import TetrisSlotMachine from "./TetrisSlotMachine";

function App() {
  return (
    <div className="App">
      <TetrisSlotMachine />
    </div>
  );
}

export default App;
